import type { CustomQuestionnaireConfigurationDto } from '#api/customQuestionnaire/index'

import type { QuestionDefinition } from '../../types'

import { getTranslation } from './utils'
import { convertToQuestions } from './v3ApiMapper'

export const useQuestionnaireConfigurationDataModel = (
	languageCode: string,
	data: CustomQuestionnaireConfigurationDto
): {
	data: QuestionDefinition[] | undefined
	title?: string
} => {
	const title = data?.customQuestionnaire.title
		? getTranslation(data.customQuestionnaire.title, languageCode) || undefined
		: undefined

	return {
		data: data ? convertToQuestions(data.customQuestionnaire, languageCode) : undefined,
		title,
	}
}
